function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0005 8H17.0005V6C17.0005 3.24 14.7605 1 12.0005 1C9.24049 1 7.00049 3.24 7.00049 6V8H6.00049C4.90049 8 4.00049 8.9 4.00049 10V20C4.00049 21.1 4.90049 22 6.00049 22H18.0005C19.1005 22 20.0005 21.1 20.0005 20V10C20.0005 8.9 19.1005 8 18.0005 8ZM9.00049 6C9.00049 4.34 10.3405 3 12.0005 3C13.6605 3 15.0005 4.34 15.0005 6V8H9.00049V6ZM18.0005 20H6.00049V10H18.0005V20ZM12.0005 17C13.1005 17 14.0005 16.1 14.0005 15C14.0005 13.9 13.1005 13 12.0005 13C10.9005 13 10.0005 13.9 10.0005 15C10.0005 16.1 10.9005 17 12.0005 17Z",
  fill: "#201858"
});

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.dd20693c.svg";
export { ForwardRef as ReactComponent };